// extracted by mini-css-extract-plugin
module.exports = {"field":"UploadLocalesSelection_field__aXprd","description":"UploadLocalesSelection_description__Y6MTD","language_buttons":"UploadLocalesSelection_language_buttons__Boltm"};